import autoBind from 'react-autobind';
import Clear from 'material-ui/svg-icons/content/clear';
import {closeCommunityInActionPhotoDialog} from '../actions';
import {connect} from 'react-redux';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import muiTheme from '../../../styles/teamologyTheme';
import {withRouter} from 'react-router';

import React, {PropTypes, Component} from 'react';

class CommunityInActionPhotoDialog extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  handleCloseDialog() {
    this.props.closeCommunityInActionPhotoDialog();
  }

  render() {
    const {isOpen, photoSrc} = this.props;

    const dialogContentStyle = {
      maxHeight: '500px',
      minHeight: '500px',
      maxWidth: '600px',
      minWidth: '600px',
    };

    return (
        <Dialog
          className="community-in-action-photo-dialog"
          modal
          open={isOpen}
          contentStyle={dialogContentStyle}
          title={
            <div className="header">
              <div><IconButton onClick={this.handleCloseDialog} iconStyle={{color: muiTheme.palette.primary1Color}}><Clear /></IconButton></div>
            </div>
          }>
          <div className="in-action-photo">
            <img src={photoSrc} />
          </div>
        </Dialog>
    );
  }
}

CommunityInActionPhotoDialog.propTypes = {
  closeCommunityInActionPhotoDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  photoSrc: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const {communityPhotoDialog} = state.features.lessonDetail.pages;

  return {
    isOpen: communityPhotoDialog.get('communityInActionPhotoDialogIsOpen'),
    photoSrc: communityPhotoDialog.get('photoSrc'),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    closeCommunityInActionPhotoDialog,
  }
)(CommunityInActionPhotoDialog));



// WEBPACK FOOTER //
// ./app/features/lessonDetail/components/CommunityInActionPhotoDialog.js